export enum UnifiedJobStatus {
    Pending,
    Processing,
    Success,
    Error
}

export interface JobAdapter<TJob> {    
    getId(job: TJob): string;
    getName?(job: TJob): string | undefined;
    getStatus(status: TJob): UnifiedJobStatus;
    getProjectId(job: TJob): string;
    getFileNameResult?(job: TJob): string;
}
